import { CenterWrapper } from '@layouts/CenterWrapper'
import type React from 'react'
import { useEffect, useState } from 'react'
import { LoadingBrand } from './LoadingBrand'
import { HELP_CENTER_HOME } from '@utils/helpLink'
import styles from './LoadingPage.module.scss'

const SUPPORT_CHAT_URL = HELP_CENTER_HOME
const SLOW_NOTICE_MS = 15_000

type LoadingPageProps = {
  title: string
}

export const LoadingPage: React.FC<LoadingPageProps> = ({
  title,
}): React.ReactNode => {
  const [showSlowNotice, setShowSlowNotice] = useState(false)

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowSlowNotice(true)
    }, SLOW_NOTICE_MS)

    return () => window.clearTimeout(timer)
  }, [])

  return (
    <CenterWrapper>
      <div
        id="lazyapp"
        className={styles.root}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <LoadingBrand title={title} />

        <p id="loading-text" className={styles.srOnly}>
          The app loading, please wait...
        </p>

        <div
          id="slownetwork-notice"
          className={`${styles.notice} ${showSlowNotice ? styles.noticeVisible : ''}`}
        >
          <p className={styles.noticeTitle}>Taking longer than usual?</p>
          <p className={styles.noticeText}>
            Try reloading the page, or contact support if this keeps happening.
          </p>
          <div className={styles.noticeActions}>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className={styles.retryButton}
            >
              Reload page
            </button>
            <p className={styles.shortcutHint}>
              <kbd className={styles.kbd}>Ctrl</kbd>
              <kbd className={styles.kbd}>F5</kbd>
              <span className={styles.shortcutSep}>/</span>
              <kbd className={styles.kbd}>⌘</kbd>
              <kbd className={styles.kbd}>⇧</kbd>
              <kbd className={styles.kbd}>R</kbd>
            </p>
            <a
              target="_blank"
              rel="noreferrer"
              href={SUPPORT_CHAT_URL}
              className={styles.supportLink}
            >
              Chat with support
            </a>
          </div>
        </div>
      </div>
    </CenterWrapper>
  )
}
